import React, { createContext, useContext } from "react";

const TeamAdminBrandContext = createContext("all");

export const TeamAdminBrandProvider = ({ brand, children }) => (
  <TeamAdminBrandContext.Provider value={brand}>
    {children}
  </TeamAdminBrandContext.Provider>
);

export const useTeamAdminBrand = () => useContext(TeamAdminBrandContext);
